import { ApplicationConfig, inject, LOCALE_ID, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { ReferenceDataService } from './services/reference-data.service';
import { catchError, firstValueFrom, of, tap, timeout } from 'rxjs';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    // Don't put anything here that requires MSAL to have run because app may hang
    // if expired token
    // App initialization is done in appInitialize (utils.ts) called from o365-auth-service
  ]
};
